import { DocumentTreeCommon } from "./DocumentTreeCommon";
import { ObservableArray } from "knockout";

export class DocumentTree {
    constructor() { }

    private privateState = {
        libraryTreeSelector: ""
    };

    public addlibraryBtn = "#dmsLibraryActions";
    public fal: any = null;
    public oldElementId: any = null;
    public treeview: kendo.ui.TreeView | null = null;
    public isAdmin: any = false;
    public forceReload: any = false;

    private changeState = (nodes: any, state: any, nest: any) => {
        for (let i = 0; i < nodes.length; i++) {
            nodes[i].set("checked", state);

            if (nodes[i].hasChildren && nest) {
                this.changeState(nodes[i].children.data(), state, nest);
            }
        }
    }

    private sortTree() {
        DocumentTreeCommon.sortTree(this.treeview);
    }

    public onCheck(e: any, checkChildren: any, tree: kendo.ui.TreeView | null) {
        if (tree === null) return;
        const $element = $(e.node);
        const name: string | undefined = $element.children("div").find('input').attr('name');
        if (name === undefined) return;
        let libraryId: any = name.replace("checkedFiles[", "").replace("]", "");
        if (libraryId === "null")
            libraryId = null;

        const node: any = tree.dataSource.get(libraryId);

        if (checkChildren && node.hasChildren) {
            this.changeState(node.children.data(), node.checked, true);
        }
        else {
            const root = tree.dataSource.get(null);
            this.changeState([root], false, false);
        }
    }

    public manageButtonDisableState() {
        $(this.addlibraryBtn).attr("disabled", 'true');
    }

    public prepareDataSource(serverResponse: any) {
        return new kendo.data.HierarchicalDataSource({
            data: serverResponse.map(function (item: any) { return DocumentTreeCommon.mapToNodes(item, true); }),
            sort: DocumentTreeCommon.sortOption,
            schema: {
                model: kendo.data.Node.define({
                    hasChildren: function (n: any) {
                        return n.items.length > 0;
                    }
                })
            }
        });
    }

    // Public API
    public init(userPermissions: any, isAdminFlag: any, selector: any, showCheckboxes: any, checkChildren: any, selectAll: any, libraryTreeSource: any, selectLibraryId: any, reload: any) {
        this.isAdmin = isAdminFlag;
        this.fal = userPermissions;

        selector = selector || {};
        this.forceReload = reload || false;
        const menuSelector = selector.menuSelector;

        this.privateState.libraryTreeSelector = selector.libraryTreeSelector;
        const promise = libraryTreeSource();
        const self: DocumentTree = this;
        promise.done(function (response: any) {
            if (!self.treeview) {
                self.initializeTreeView(response, selectLibraryId, checkChildren);
            } else if (self.forceReload) {
                self.reloadTreeView(response);
            }

            self.selectFirstNode();

            if (window.location.hash || window.location.search) {
                const id = self.getHashParameterByName("libraryId") || self.getQueryStringParameterByName("libraryId");

                if (self.treeview) {
                    self.treeview.expandTo(id);
                    self.selectNode(id, true);
                }
            }
        });
        return promise;
    }

    private initializeTreeView(response: any, selectLibraryId: any, checkChildren: any) {
        const dataSource = this.prepareDataSource(response);
        const template = this.getTemplate();
        const treeElement: Element | null = document.getElementById(this.privateState.libraryTreeSelector.replace("#", ""));
        if (treeElement !== null) {
            this.treeview = new kendo.ui.TreeView(treeElement,
                {
                    dataSource: dataSource,
                    dataBound: () => {
                        if (selectLibraryId) {
                            this.selectLibrary(selectLibraryId, true);
                        }
                    },
                    check: (e) => {
                        this.onCheck(e, checkChildren, this.treeview);
                    },
                    loadOnDemand: false,
                    template: template,
                    checkboxes: {
                        template: "<span class='checkbox checkbox-primary'><input  class='form-check-input' type='checkbox' name='checkedFiles[#: item.id #]' value='true' /><label for='checkedFiles[#: item.id #]'></label></span>&nbsp;"
                    },
                    expand: this.expandNode,
                    collapse: this.collapseNode,
                });

            DocumentTreeCommon.initExpandNode(this.treeview);
        }
    }

    private reloadTreeView(response: any) {
        if (this.treeview == null) return;
        this.treeview.setDataSource(this.prepareDataSource(response));
        this.treeview.dataSource.read();
    }

    private selectFirstNode() {
        this.selectNode(null, true);
    }

    private getTemplate() {
        return "<span style='white-space:nowrap;'># if (item.expanded) { #" +
            "<span><i class='fa fa-folder-open'></i></span>" +
            "# } else  {#" +
            "<span><i class='fa fa-folder'></i></span>" +
            "# } #" +
            "# if (item.hasChildren) { #" +
            "&nbsp;<span class='folder-has-children'>#: item.name #</span>" +
            "# } else { #" +
            "&nbsp;<span>#: item.name #</span>" +
            "# } #</span>";
    }

    private expandNode(this: kendo.ui.TreeView, e: any) {
        var node = e.node;
        var child = node?.querySelector(".fa-folder");
        if (child !== null && child !== undefined) {
            child.classList.remove("fa-folder");
            child.classList.add("fa-folder-open");
        }
    }

    private collapseNode(this: kendo.ui.TreeView, e: any) {
        var node = e.node;
        var child = node?.querySelector(".fa-folder-open");
        if (child !== null && child !== undefined) {
            child.classList.remove("fa-folder-open");
            child.classList.add("fa-folder");
        }
    }


    public selectLibrary(libraryId: number, check: boolean) {
        if (!this.treeview) return null;
        const library = this.treeview.dataSource.get(libraryId);
        if (!library) {
            return null;
        }

        this.treeview.findByUid(library.uid);
        const selected = this.treeview.findByUid(library.uid);
        this.treeview.select(selected);

        if (check) {
            library.set("checked", true);
        }

        return selected;
    }

    public getSelectionPath() {
        if (!this.treeview) return null;

        const selected = this.treeview.select();
        const path = $(selected).parentsUntil($("#treeview"), "li");
        const items = [this.treeview.dataItem(selected)];
        $.each(path, (index, value) => {
            if (this.treeview) items.push(this.treeview.dataItem(value));
        });

        return items.reverse();
    }

    public getSelectedLibraryId() {
        if (!this.treeview) return null;
        const selected = this.treeview.select();
        return this.treeview.dataItem(selected).id;
    }

    public selectNode(nodeId: any, forceReload: any) {
        if (!this.treeview) //in case of section unloaded meantime
            return;
        const dataItem = this.treeview.dataSource.get(nodeId);
        if (!dataItem)
            return;
        const node = this.treeview.findByUid(dataItem.uid);

        const selectedDataItem = this.treeview.dataItem(this.treeview.select());
        if (!!selectedDataItem && selectedDataItem.id === nodeId) {
            return;
        }

        this.treeview.select(node);
    }

    public getSelectedLibrary() {
        if (this.treeview === null) return;
        return this.treeview.select();
    }

    public isRootLibrary(selectedNode: any) {
        if (this.treeview === null) return;
        const node = this.treeview.dataItem(selectedNode);
        return node ? !node.id : false;
    }

    public getCheckedNodeIds() {
        const checkedNodes: number[] = [];
        if (!this.treeview) return checkedNodes;
        const _checkedNodeIds = function (nodes: any, checkedNodes: number[]) {
            for (let i = 0; i < nodes.length; i++) {
                if (nodes[i].checked && nodes[i].id) {
                    checkedNodes.push(nodes[i].id);
                }

                if (nodes[i].hasChildren) {
                    _checkedNodeIds(nodes[i].items, checkedNodes);
                }
            }
        }

        _checkedNodeIds(this.treeview.dataSource.view(), checkedNodes);
        return checkedNodes;
    }

    public getCheckedNodePaths() {
        const checkedNodesPaths: any[] = [];
        if (!this.treeview) return null;
        const _checkedNodePaths = function (nodes: any, checkedNodes: any[]) {
            for (let i = 0; i < nodes.length; i++) {
                if (nodes[i].checked && nodes[i].id) {
                    checkedNodesPaths.push(nodes[i].textToSort);
                }

                if (nodes[i].hasChildren) {
                    _checkedNodePaths(nodes[i].items, checkedNodesPaths);
                }
            }
        }

        _checkedNodePaths(this.treeview.dataSource.view(), checkedNodesPaths);
        return checkedNodesPaths;
    }

    public getQueryStringParameterByName(name: string): string {
        return this.getUrlParameterByName(name, "?&");
    }

    public getHashParameterByName(name: string): string {
        return this.getUrlParameterByName(name, "#");
    }

    public getUrlParameterByName = function (name: string, prefixes: string): string {
        name = name.replace(/[\[\]]/g, "\\$&");
        const regex = new RegExp("[" + prefixes + "]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(window.location.href);

        if (!results) return "";
        if (!results[2]) return '';

        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
}